import { render, staticRenderFns } from "./ComplaintAllDealView.vue?vue&type=template&id=24d3825e&"
import script from "./ComplaintAllDealView.vue?vue&type=script&lang=js&"
export * from "./ComplaintAllDealView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports